import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { MediumCenteredContainer } from '@eika/engine-view';

import { fetchNafMember } from '../actions';
import { DispatchWithState, StringKeyValue } from '../actions/types';
import Loading from '../components/Messages/Loading';
import NafMemberCheckForm from '../components/Naf/NafMemberCheckForm';
import { AppState } from '../reducers';
import { LoaderReducer } from '../reducers/loader';
import { NafFormType, NafReducer } from '../reducers/naf';
import { UserReducer } from '../reducers/user';

interface Props {
    action: {
        fetchNafMember: (form: NafFormType) => DispatchWithState;
    };
    loader: LoaderReducer;
    text: StringKeyValue;
    naf: NafReducer;
    user: UserReducer;
}

const NafMemberCheck = (props: Props) => {
    const { loader, action, naf, text, user } = props;
    const navigate = useNavigate();

    useEffect(() => {
        if (naf.isMember) navigate('/');
    }, [navigate, naf.isMember]);

    if (!loader.hasFetchedNafCache) return <Loading title={text.loadingDefault} />;
    return (
        <MediumCenteredContainer>
            <>
                <h1>{text.processTitlev2}</h1>
                <p>{text.nafMedlemSjekkInfoTekst}</p>
                <NafMemberCheckForm loader={loader} action={action} naf={naf} text={text} user={user} />
            </>
        </MediumCenteredContainer>
    );
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    loader: state.loader,
    naf: state.naf,
    user: state.user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            fetchNafMember,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NafMemberCheck);
